import React from 'react';
import { useLocation, useHistory, Redirect } from 'react-router-dom';
import { PageContainer } from '@ant-design/pro-layout';
import { Tag } from 'antd';
import { GET_CURRENT_REPORTING_PERIOD } from 'gql/reportingPeriod';
import Main from '../layout/Main';
import Reports from './Reports';
import Projects from './Projects';
import './index.less';
import { useQuery } from '@apollo/client';
import { DateDisplay } from 'components/layout';
import useHasAnyScopeType from 'hooks/useHasAnyScopeType';
import { SCOPE_TYPES } from 'constants/scopes';

const getContentList = (hash) => {
  switch (hash) {
    case '#projects':
      return <Projects />;
    case '#reports':
      return <Reports />;
    default:
      return <Reports />;
  }
};
const getTabList = ({ hasScopeTypeReports, hasScopeTypeProjects, loading }) => {
  if (loading) return [];
  const result = [];
  if (hasScopeTypeReports) {
    result.push({
      key: '#reports',
      tab: 'Report Submission',
    });
  }

  if (hasScopeTypeProjects) {
    result.push({
      key: '#projects',
      tab: 'Projects',
    });
  }
  return result;
};

const AnnualReports = () => {
  const history = useHistory();
  const { hash } = useLocation();
  const { data, loading } = useQuery(GET_CURRENT_REPORTING_PERIOD);
  const { hasScopeType: hasScopeTypeReports, loading: loadingReports } =
    useHasAnyScopeType([
      SCOPE_TYPES.VIEW_ALL_ANNUAL_REPORT,
      SCOPE_TYPES.VIEW_ANNUAL_REPORT,
      SCOPE_TYPES.WRITE_ANNUAL_REPORT,
      SCOPE_TYPES.WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE,
    ]);
  const { hasScopeType: hasScopeTypeProjects, loading: loadingProjects } =
    useHasAnyScopeType([SCOPE_TYPES.VIEW_ANNUAL_REPORT_PROJECT]);

  const handleTabChange = (key) => {
    history.push(`/annual-reports${key}`);
  };

  const getTabKey = () => {
    if (hash && hash !== '') {
      return hash;
    }
    return '#reports';
  };

  if (
    !hasScopeTypeReports &&
    !loadingReports &&
    hash === '#reports' &&
    hasScopeTypeProjects &&
    !loadingProjects
  ) {
    return <Redirect to="/annual-reports#projects" />;
  }
  if (
    hasScopeTypeReports &&
    !loadingReports &&
    hash === '#projects' &&
    !hasScopeTypeProjects &&
    !loadingProjects
  ) {
    return <Redirect to="/annual-reports#reports" />;
  }

  return (
    <Main style={{ padding: 0 }}>
      <PageContainer
        loading={loading || loadingReports || loadingProjects}
        className="annual-report-container"
        header={{ title: 'F/SLTC Annual Report' }}
        ghost
        content={
          <Tag
            color="#546e7a"
            style={{ fontSize: '16px', padding: '8px', margin: '-8px 0' }}
          >
            Current Reporting Period:{' '}
            <DateDisplay date={data?.currentReportingPeriod?.startDate} /> -{' '}
            <DateDisplay date={data?.currentReportingPeriod?.endDate} />
          </Tag>
        }
        onTabChange={handleTabChange}
        tabActiveKey={getTabKey()}
        tabList={getTabList({
          hasScopeTypeReports,
          hasScopeTypeProjects,
          loading,
        })}
      >
        {getContentList(hash)}
      </PageContainer>
    </Main>
  );
};

export default AnnualReports;
